import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES } from '../../config/url.servicio'
import { Storage } from '@ionic/storage'

@Injectable()
export class DenominacionesProvider {
  constructor(public http: Http,  private storage: Storage,) {
    this.storage.get('companiasId').then((val)=>{
      this.buscar(val)
    })
  }

  buscar(companiasId:any) {
    const url =  URL_SERVICIOS_AWS;
      let data = {
        name: "buscarDenominaciones",
        parameters : {companiasId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options)
      .map((data) => data.json())
  }

  buscarTodasLasDenominaciones(companiasId:any) {
    const url =  URL_SERVICIOS_AWS;
      let data = {
        name: "buscarTodasLasDenominaciones",
        parameters : {companiasId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options)
      .map((data) => data.json())
  }



  buscarCorreo(companiasId:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarcorreos",
        parameters : {companiasId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=buscarcorreos&companiasId=${companiasId}`)
      .map((data) => data.json())
    }
  }
  buscarFormasDePago(companiasId:any) {
    const url =  URL_SERVICIOS_AWS;
      let data = {
        name: "buscarFormasDePago",
        parameters : {companiasId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options)
      .map((data) => data.json())
  }

}



// WEBPACK FOOTER //
// ./src/providers/denominaciones/denominaciones.ts